/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Sample_HeadingInputs */

const ja_playdata_home_sample_heading = /** @type {(inputs: Playdata_Home_Sample_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプルレポート`)
};

const en_playdata_home_sample_heading = /** @type {(inputs: Playdata_Home_Sample_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample Event Report`)
};

/**
* | output |
* | --- |
* | "Sample Event Report" |
*
* @param {Playdata_Home_Sample_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_sample_heading = /** @type {((inputs?: Playdata_Home_Sample_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Sample_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_sample_heading(inputs)
	return en_playdata_home_sample_heading(inputs)
});